// Build information, automatically generated by `ng-info`
const build = {
    version: "22.4.0",
    timestamp: "Mon Apr 14 2025 14:51:17 GMT+0200 (Central European Summer Time)",
    message: null,
    git: {
        user: null,
        branch: "HEAD",
        hash: "3cbb9e",
        fullHash: "3cbb9ece264ee5bf715346142a8d5440b8453853"
    }
};

export default build;